<ion-content>
  <div class="loader-container">
    <ion-spinner></ion-spinner>
  </div>
</ion-content>
